import {
  Box,
  formatDateWithTimeAndTimezone,
  Notification,
} from '@omnipresentgroup/design-system';
import { useCutoffDates } from '@omnipresentgroup/domains';
import { useMemo } from 'react';

export const ExpenseDetailsCutOffNotification = ({
  legalEntityId,
}: {
  legalEntityId: string;
}) => {
  const { data: cutoffDatesData } = useCutoffDates({
    legalEntityId,
    enabled: Boolean(legalEntityId),
  });

  const nextCutOffDate = useMemo(
    () => cutoffDatesData?.[0]?.cutoffDates?.[0],
    [cutoffDatesData],
  );

  return (
    <Box data-testing="blackout">
      {nextCutOffDate && (
        <Notification
          id="expense-details-cutoff-alert"
          intent="info"
          title={`Approve by ${formatDateWithTimeAndTimezone(
            nextCutOffDate,
          )} to ensure this expense is included in this month's payroll.`}
        />
      )}
    </Box>
  );
};
